import { render } from "./new-category.vue?vue&type=template&id=8efb8f38"
import script from "./new-category.vue?vue&type=script&lang=js"
export * from "./new-category.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__